import { Button } from '@bizora/ui'
import { Check } from 'lucide-react'
import { Link } from 'react-router-dom'

export function Pricing() {
  const plans = [
    {
      name: 'Starter',
      price: 999,
      period: 'per month',
      description: 'Perfect for small businesses getting started',
      features: [
        'Up to 100 orders/month',
        'Basic catalog management',
        'Customer database',
        'Email support',
        'Basic analytics'
      ],
      cta: 'Start Free Trial',
      popular: false
    },
    {
      name: 'Growth',
      price: 2499,
      period: 'per month',
      description: 'For growing businesses',
      features: [
        'Unlimited orders',
        'Advanced catalog features',
        'Subscription management',
        'Priority support',
        'Advanced analytics',
        'Loyalty programs',
        'Multi-location support'
      ],
      cta: 'Start Free Trial',
      popular: true
    },
    {
      name: 'Pro',
      price: 4999,
      period: 'per month',
      description: 'For established businesses',
      features: [
        'Everything in Growth',
        'Advanced routing & delivery',
        'Custom integrations',
        'Dedicated support',
        'Custom reporting',
        'API access',
        'White-label options'
      ],
      cta: 'Contact Sales',
      popular: false
    }
  ]

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold text-neutral-900 mb-4">Pricing</h1>
          <p className="text-xl text-neutral-600">
            Choose the plan that works for your business
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {plans.map((plan, idx) => (
            <div
              key={idx}
              className={`bg-white rounded-xl border-2 p-8 ${
                plan.popular
                  ? 'border-primary-600 shadow-lg relative'
                  : 'border-neutral-200'
              }`}
            >
              {plan.popular && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2">
                  <span className="bg-primary-600 text-white px-4 py-1 rounded-full text-sm font-medium">
                    Most Popular
                  </span>
                </div>
              )}
              <h2 className="text-2xl font-bold text-neutral-900 mb-2">{plan.name}</h2>
              <p className="text-neutral-600 mb-6">{plan.description}</p>
              <div className="mb-6">
                <span className="text-5xl font-bold text-neutral-900">₹{plan.price}</span>
                <span className="text-neutral-600 ml-2">/{plan.period}</span>
              </div>
              <ul className="space-y-3 mb-8">
                {plan.features.map((feature, featureIdx) => (
                  <li key={featureIdx} className="flex items-start gap-3">
                    <Check className="w-5 h-5 text-success-500 flex-shrink-0 mt-0.5" />
                    <span className="text-neutral-700">{feature}</span>
                  </li>
                ))}
              </ul>
              <Link to="/register" className="block">
                <Button
                  variant={plan.popular ? 'primary' : 'ghost'}
                  className="w-full"
                  size="lg"
                >
                  {plan.cta}
                </Button>
              </Link>
            </div>
          ))}
        </div>
      </div>
  )
}

